import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  CalcTourPackageRequest,
  CalcTourPackageResponse,
  GetOtherFlightsRequest,
  GetOtherFlightsResponse,
  SearchTourPackagesRequest,
  SearchTourPackagesResponse
} from '@appTypes/api.types';
import { environment } from '@env/environment';
import { GetFlightUpgradesRequest, GetFlightUpgradesResponse } from '../tour-flight-upgrade.types';
import { ShownDismissResponse, ShownRowActionRequest } from '../tours-row-checks.types';

@Injectable({ providedIn: 'root' })
export class ToursApiService {
  readonly #httpClient = inject(HttpClient);

  readonly #apiEndPoint: string = environment.urls.api + '/TourPackages/';

  searchTourPackages(payload: SearchTourPackagesRequest) {
    // The result table reads no transfer option list, and the package details load the full lists with CalcPackage, so the search
    // keeps only the selected transfer per direction: 86 % of a result was option lists (972 KB a page, 29.09.2026).
    // ADR-0030 (R-1d): the rows of the list, its pages, sorts, polls and hotel groups carry only what a row shows; an opened offer is CalcPackage's.
    return this.#httpClient.post<SearchTourPackagesResponse>(this.#apiEndPoint + 'SearchTourPackages', {
      ...payload,
      compactTransferOptions: true,
      slimRows: true
    });
  }
  /** R-P2-6 "Remove from list": the only way a row leaves the page; the answer carries the new count. */
  dismissRow(payload: ShownRowActionRequest) {
    return this.#httpClient.post<ShownDismissResponse>(this.#apiEndPoint + 'ShownPageChecks/Dismiss', payload);
  }
  getOtherFlights(payload?: GetOtherFlightsRequest) {
    return this.#httpClient.post<GetOtherFlightsResponse>(this.#apiEndPoint + 'GetOtherFlights', payload);
  }
  /** R-U1: the higher cabins the suppliers sell on the tour's flight, each priced as a whole package (phase 3 of flight cabin classes). */
  getFlightUpgrades(payload: GetFlightUpgradesRequest) {
    return this.#httpClient.post<GetFlightUpgradesResponse>(this.#apiEndPoint + 'GetFlightUpgrades', payload);
  }
  calcPackage(payload?: CalcTourPackageRequest) {
    return this.#httpClient.post<CalcTourPackageResponse>(this.#apiEndPoint + 'CalcPackage', {
      ...payload
      // refreshPrices: true
    });
  }
}
